import {List} from 'immutable';

const DAYS = List()
    .setSize(7)
    .map((_, i) => i + 1);

const DISPLAY_MODE = {
    DETAILED_BREAKDOWN: 0,
    SPLIT_AM_PM_12: 1,
    SPLIT_AM_PM_1: 2,
    SPLIT_AM_PM_12_30: 3,
    FULL_DAY: 4,
};

const SORTING = {
    BY_NAME: 'BY_NAME',
    BY_ASCENDING_AGE: 'BY_ASCENDING_AGE',
    BY_DESCENDING_AGE: 'BY_DESCENDING_AGE',
};

export default {
    ATTENDING: 'ATTENDING',
    SICK: 'SICK',
    VACATION: 'VACATION',
    ABSENT: 'ABSENT',
    DAYS,
    DISPLAY_MODE,
    SORTING,
};
